import { TOKEN_ICONS } from './tokenIcons';
import { Token } from './types';

export const VLP_TOKEN_INFO: Pick<Token, 'symbol' | 'icon'> = {
  symbol: 'VLP',
  icon: TOKEN_ICONS.vlp,
};
